<template>
	<div class="bigLogo">
		<img class="logo top_logo" src="@/assets/hp_logo_v.svg"/>
	</div>
</template>

<script>
export default {
	data() {
		return {
			bodyScrollPos: 0
		};
	},
	mounted() {
		this.$nextTick(function(){
			
			window.addEventListener('scroll', this.bodyScrolling);
			
			setTimeout(function(){
				this.bodyScrolling();
			}.bind(this), 100);
		});
	},
	destroyed() {
		window.removeEventListener('scroll', this.bodyScrolling);
	},
	methods: {
		bodyScrolling() {
			let logo = document.getElementsByClassName("top_logo")[0];
			if (logo == undefined) {
				return;
			}
			
			let y = document.documentElement.scrollTop || document.body.scrollTop;
			
			if (y < 250) {
				let lt = 68 - y;
				logo.style.top = lt + "px";
				let p = (250 - y) / 250;
				logo.style.transform = 'scale(' + p + ')';
			} else {
				logo.style.top = "-178px";
				let p = 0;
				logo.style.transform = 'scale(' + p + ')';
			}
		}
	}
}
</script>

<style lang="less" scoped>
.bigLogo {
	.top_logo {
		position: absolute;
		width: 16%;
		left: calc((100% - 16%) / 2);
		top: 68px;
		z-index: 9999;
	}
}

@media(max-width:420px) {
	.bigLogo {
		.top_logo {
			position: absolute;
			width: 30%;
			left: calc((100% - 30%) / 2);
			top: 68px;
			z-index: 9999;
		}
	}
}
</style>
